var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew201({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "5.85 14 11.24 4.67 0.46 4.67 5.85 14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,6.7V2h.66l1.51,2.38A12.56,12.56,0,0,1,15,5.9h0C15,5.27,15,4.7,15,4V2h.57V6.7h-.62L13.43,4.32a18,18,0,0,1-.88-1.57h0c0,.6.05,1.16.05,1.94v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew201);
export default __webpack_public_path__ + "static/media/Symbolpack_New_201.2cf113b85d7173e1b5b5d81f091803cf.svg";
export { ForwardRef as ReactComponent };